<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="600px">
    <v-card style="border-radius: 30px !important;">

      <Recaptcha ref="recaptcha" @verify="(response) => customSubmit(response)" />

      <v-row no-gutters align="center">

        <!-- Title + Close icon -->
        <v-col cols="12" class="mt-6">
          <v-row no-gutters>
            <v-col cols="8" class="offset-2">
              <h2 class="font-weight-bold text-center" style="margin:0 auto !important;">{{$t('account.askResetPassword.title')}}</h2>
            </v-col>
            <v-col cols="1" class="offset-1">
              <v-btn icon @click="close(false)">
                <v-icon color="primary">fal fa-times</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>

        <!-- Subtitle -->
        <v-col cols="12" class="mt-6 px-3">
          <p class="text-center" v-html="$t('account.askResetPassword.subtitle')" />
        </v-col>

        <!-- Form -->
        <v-col cols="12" md="10" class="offset-md-1 mt-3">
          <v-form @submit.prevent>
            <v-row no-gutters>

              <!-- Email -->
              <v-col cols="12">
                <v-text-field
                  dense
                  :label="$t('account.askResetPassword.labels.email')"
                  v-model="form.email"
                  :error-messages="errors.email"
                  @input="validateEmail"
                  @keyup.enter="executeRecaptcha"
                  outlined>
                  <template v-slot:prepend>
                    <img width="20" src="@/assets/icons/controls/user_off.svg" />
                  </template>
                </v-text-field>
              </v-col>

              <!-- Alert -->
              <v-col cols="12">
                <AlertBar />
              </v-col>
            </v-row>
          </v-form>
        </v-col>

        <!-- Button -->
        <v-col cols="12" class="my-6">
          <v-row no-gutters justify="center">
            <v-btn
              @click="(e) => executeRecaptcha(e)"
              rounded
              :disabled="!(!!form.email)"
              width="150"
              color="primary"
              class="font-weight-bold"
              :loading="isLoadingBtn"
              style="border-radius: 10px !important;font-size: 16px !important;"
            >
              {{$t('account.askResetPassword.buttons.submit')}}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

    </v-card>
  </v-dialog>
</template>

<script>
  import dialogMixin from "@/mixins/dialog"
  import validator from "validator";

  export default {

    name: "AskResetPassword",

    components: {

      AlertBar: () => import("@/components/Common/AlertBar"),
      Recaptcha: () => import("@/components/Common/Recaptcha")
    },

    mixins: [dialogMixin],

    data() {

      return {

        defaultForm: {
          email: ""
        },

        errors: {
          email: null
        },

        isLoadingBtn: false
      }
    },

    methods: {
      executeRecaptcha(event) {
        event.stopPropagation();
        this.$refs.recaptcha.execute();
      },

      customSubmit(recaptcha) {

        this.validateEmail();

        if (!Object.values(this.errors).some((el) => el !== null)) {

          this.isLoadingBtn = true;
          // Submit
          this.form["g-recaptcha-response"] = recaptcha;

          this.$http
          .post(`/map/users/forgot-password`, this.form)
          .then(res => {

            this.form = {...this.default_form};
            this.$store.commit("toast/showSuccess", this.$t('account.askResetPassword.success'));
            this.close();
          })
          .catch(err => {
            //console.log(err);
            if (err && err.response && err.response.status === 400 && err.response.data)
              this.$store.commit("alert/showError", this.$t(`account.askResetPassword.errors.${err.response.data.type}`));
            else
              this.$store.commit("alert/showError", this.$t(`common.errors.500`));
          })
          .finally(() => this.isLoadingBtn = false);
        }
      },

      validateEmail() {
        if (this.form.email)
        {
          this.errors.email = validator.isEmail(this.form.email) ? null : this.$t('account.registration.errors.EMAIL_INVALID');
        } else
          this.errors.email = this.$t('common.errors.IS_REQUIRED');
      },
    }
  }
</script>

<style scoped>

</style>